export const API_ROUTES = {
  USER_INFO: "/api/apps/userInfo",
  STORE_TOKEN: "/api/apps/auth/store-token",
  CLEAR_COOKIES: "/api/apps/auth/clear-cookies",
  GET_NEW_TOKEN: "/api/apps/auth/accessToken",
  LOGIN: "/api/apps/auth/login",
  RESPOND_CHALLENGE: "/api/apps/auth/respond-challenge",
  FORGOT_PASSWORD: "/api/apps/auth/forgot-password",
  CONFIRM_FORGOT_PASSWORD: "/api/apps/auth/confirm-forgot-password",
};
